import {Component, OnInit, ViewChild} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthTokenService} from '../../../shared/services/auth-token.service';
import {SurveyService} from '../surveys.service';
import {
  ReportListItemModel,
  MasterSummaryPDModel,
  ReportForPeopleModel
} from '../../../models/survey/survey.model';
import {PreviousUrlService} from '../../../shared/services/previous-url.service';
import {PeopleModel} from '../../../models/people/people.model';
import CustomStore from 'devextreme/data/custom_store';
import {DxDataGridComponent} from 'devextreme-angular';
import {ToasterService} from 'angular5-toaster/dist';
import {
  generateNizPitanja,
  showAvgNumericFirstOption,
  showBarChartFirstOption,
  showPieChartFirstOption
} from '../../../shared/helpers/chart-helper';

@Component({
  selector: 'app-analysis',
  templateUrl: './analysis.component.html',
  styleUrls: ['./analysis.component.less']
})
export class AnalysisComponent implements OnInit {
  choseSurvey = false;
  dropdown = false;
  filter = false;
  people: Array<any>;
  column = 'gender';
  isDesc = false;
  report = false;
  box = false;
  list = false;
  showPrint = false;
  dropdownLabel = 'Choose a Report';
  surveyId: number;
  surveyTitle: string;
  listReportItemModel: ReportListItemModel;
  surveyMasterSummaryPDModel: MasterSummaryPDModel;
  predefinedReportId: number;
  loader = false;
  reportForPeopleModel: ReportForPeopleModel;
  user: PeopleModel;
  showUserPopup: boolean;

  dataSource: any = {};
  reportId: number;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;


  constructor(private toast: ToasterService,
              private router: Router,
              private route: ActivatedRoute,
              private surveyService: SurveyService,
              private shareService: PreviousUrlService) {
    this.route.params.subscribe();
    this.dataSource.store = new CustomStore({
      load: (loadOptions: any) => {
        // console.log(loadOptions);

        const page = !loadOptions.skip ? 0 : loadOptions.skip / loadOptions.take;
        return this.surveyService.getReportForPeople(this.reportId, page).toPromise().then((data: any) => {
          this.reportForPeopleModel = data;
          return {
            data: data.listPeople,
            totalCount: data.totalRecordCount,
          };
        });
      }
    });
  }

  ngOnInit() {
    this.surveyId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.surveyTitle = this.route.snapshot.paramMap.get('title');
    this.shareService.setSurveyTitle(this.surveyTitle);
    this.getReports();
  }

  openUserPopup(user) {
    this.user = user;
    this.showUserPopup = true;
  }

  sort(user) {
    this.isDesc = !this.isDesc;
    this.column = user;
    const direction = this.isDesc ? 1 : -1;

    this.people.sort(function (a, b) {
      if (a[user] < b[user]) {
        return -1 * direction;
      } else if (a[user] > b[user]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
    }
  }

  selectReport(e) {
    if (this.dataGrid) {
      this.dataGrid.instance.pageIndex(0);
    }

    this.box = false;
    this.showPrint = false;
    this.loader = true;
    this.list = true;

    this.reportId = e.id;
    if (this.dataGrid) {
      this.dataGrid.instance.refresh();
    }

    this.surveyService.getReport(e.id, 0).subscribe(response => {
        this.loader = false;
        this.surveyMasterSummaryPDModel = response;

        for (const item of this.surveyMasterSummaryPDModel.listQuestionModel) {
          item.haveAnswered = 'Have Answered';
          item.haveNotAnswered = 'Have Not Answered';
          item.nizPitanja = generateNizPitanja(item);
          item.barChart = showBarChartFirstOption(item.answerType);
          item.chart = showPieChartFirstOption(item.answerType);
          item.averageResponse = showAvgNumericFirstOption(item.answerType);
        }
        this.list = true;

      },
      (error) => {
        this.loader = false;
      }
    );


  }


  printButton(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }


  toggleSurvey() {
    this.choseSurvey = !this.choseSurvey;
  }

  toggleDropdown() {
    this.dropdown = !this.dropdown;
  }


  showBox() {
    if (!this.reportId) {
      this.toast.pop('error', 'Please choose a Report!');
      return;
    }

    this.box = true;
    this.list = false;
    this.showPrint = true;
  }

  showList() {
    if (!this.reportId) {
      this.toast.pop('error', 'Please choose a Report!');
      return;
    }

    this.list = true;
    this.box = false;
  }

  getReports() {
    this.loader = true;
    this.surveyService.getReports(this.surveyId)
      .subscribe((response) => {
          this.listReportItemModel = response;
          this.loader = false;
          this.predefinedReportId = parseInt(this.route.snapshot.paramMap.get('rid'));
          if (this.predefinedReportId > 0) {
            const report = this.listReportItemModel.listReportItemModel.find(a => a.id === this.predefinedReportId);
            this.dropdownLabel = report.name;
            this.selectReport(report);
          }
        },
        (error) => {
          this.loader = false;
        });
  }

  downloadAsCsv() {
    if (!this.reportId) {
      this.toast.pop('error', 'Please choose a Report!');
      return;
    }

    const headers = new Headers({
      'Content-Type': 'text/csv'
    });

    let data = '';

    for (const item of this.surveyMasterSummaryPDModel.listQuestionModel) {

      data += item.questionName.split(',').join(' ');
      if (item.listAnswerModel.length > 0) {
        data += ','.repeat(item.listAnswerModel.length);
      } else {
        data += ','.repeat(2);
      }
    }

    data += '\r\n';

    for (const item of this.surveyMasterSummaryPDModel.listQuestionModel) {
      item.haveAnswered = 'Have Answered';
      item.haveNotAnswered = 'Have Not Answered';
      if (item.listAnswerModel.length > 0) {
        for (const x of item.listAnswerModel) {
          data += x.answerName.split(',').join(' ') + ',';
        }
      } else {
        data += item.haveAnswered + ',';
        data += item.haveNotAnswered + ',';
      }
    }

    data += '\r\n';

    for (const item of this.surveyMasterSummaryPDModel.listQuestionModel) {
      if (item.listAnswerModel.length > 0) {
        for (const x of item.listAnswerModel) {
          data += x.answerCount + ',';
        }
      } else {
        data += item.answeredCount + ',';
        data += item.nonAnsweredCount + ',';
      }
    }


    data += '\r\n';

    for (const item of this.surveyMasterSummaryPDModel.listQuestionModel) {
      if (item.listAnswerModel.length > 0) {
        for (const x of item.listAnswerModel) {
          data += x.answerPercentage + '%' + ',';
        }
      } else {
        data += item.answeredPercentage + '%' + ',';
        data += item.nonAnsweredPercentage + '%' + ',';

      }
    }

    this.downloadFile(data);
  }

  downloadFile(data) {
    let blob = new Blob(['\ufeff' + data], { type: 'attachment/csv' });
    let url = window.URL.createObjectURL(blob);

    if(navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, 'report.csv');
    } else {
        let a = document.createElement('a');
        a.href = url;
        a.download = 'report.csv';
        document.body.appendChild(a);
        a.click();        
        document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/analysis/analysis.component.ts